import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import { useTreatmentContext } from '../../../../../Services/TreatmentContext';
import ElectronicVaccinationReactionCancellationConfirmation, {
	ElectronicVaccinationReactionCancellationConfirmationValues,
} from './ElectronicVaccinationReactionCancellationConfirmation';
import { Size } from '../../../../../Enums/Size.enum';

interface Props {
	isOpen: boolean;
	onClose: () => void;
	onSubmit: (
		values: ElectronicVaccinationReactionCancellationConfirmationValues,
	) => void;
}

const ElectronicVaccinationReactionCancellationConfirmationModal: React.FC<
	Props
> = ({ isOpen, onClose, onSubmit }) => {
	const { isCase } = useTreatmentContext();

	return (
		<Modal opened={isOpen} onClose={onClose} wrapChat={isCase} size={Size.SM}>
			<Modal.Header
				title='nczi.electronicVaccinationReactionCancellationConfirmation.cancelRecord'
				firstUpper
			/>
			<Modal.Content contentScroll>
				<ElectronicVaccinationReactionCancellationConfirmation
					onSubmit={onSubmit}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicVaccinationReactionCancellationConfirmationModal;
